import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
}

export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  danger = true,
}: ConfirmModalProps) {
  const { t } = useTranslation();
  const resolvedConfirmLabel = confirmLabel ?? t('common.delete', 'Delete');
  const resolvedCancelLabel = cancelLabel ?? t('common.cancel', 'Cancel');
  return (
    <Modal
      title={title}
      onClose={onCancel}
      width="sm"
      footer={
        <>
          <button
            type="button"
            onClick={onCancel}
            className="rounded border border-csm-border bg-white px-3 py-1.5 text-csm-sm text-csm-ink hover:bg-csm-surface-alt"
          >
            {resolvedCancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`rounded px-3 py-1.5 text-csm-sm text-white ${
              danger
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-primary hover:bg-primary-hover'
            }`}
          >
            {resolvedConfirmLabel}
          </button>
        </>
      }
    >
      <div className="flex items-start gap-3 py-2">
        <div className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${danger ? 'bg-red-100' : 'bg-amber-50'}`}>
          <svg viewBox="0 0 20 20" fill="currentColor" className={`h-4 w-4 ${danger ? 'text-red-600' : 'text-amber-500'}`}>
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
        </div>
        <p className="text-csm-sm text-csm-ink">{message}</p>
      </div>
    </Modal>
  );
}
